import React from 'react'
import {
  formatStem,
  getMainQuestionStrNum,
  getSubQuestionsByParentId,
} from '../utils'
import { PaperBlock, PaperQuestion } from 'packages/sdks-next/growp'
import styled from 'styled-components'
import { RenderQuestionBlock } from '../Blocks/RenderQuestionBlock'
import { RichTextRenderer } from 'packages/components/RichText'
import { useAnswersManagement } from '../context'

export const ProductAnswer: React.FC<{
  block: PaperBlock
  mainQuestion: PaperQuestion
}> = ({ block, mainQuestion }) => {
  const subQuestions = getSubQuestionsByParentId(
    block.questions || [],
    mainQuestion.id
  )
  const { blocks, showScore } = useAnswersManagement()
  const blockNum = getMainQuestionStrNum(blocks, block.id)
  const { type, score, stem } = mainQuestion
  const finalStem = formatStem({
    type,
    score,
    stem,
    showScore,
  })
  return (
    <Wrapper>
      <BlockNumWrapper>{blockNum}.</BlockNumWrapper>
      <div style={{ flexGrow: 1 }}>
        <RichTextRenderer value={finalStem || ''} />
        <SubWrapper>
          {subQuestions.map((question, index) => {
            return (
              <RenderQuestionBlock
                key={question.id}
                mainQuestion={question}
                block={block}
                currentNum={index + 1}
              />
            )
          })}
        </SubWrapper>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

const SubWrapper = styled.div`
  padding: 8px 0 8px 0px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const BlockNumWrapper = styled.div`
  width: 24px;
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  font-weight: normal;
  color: ${(props) => props.theme.text._1};
`
